/* =========================================================================
   Khurat — Shared product card behaviour for snippets/card-product-shop.liquid
   Used by the collection grid and the home page product sections.

   - Variant option pills: pick a value per option, resolve the variant, sync
     price / compare-at / savings / the add-to-cart button, and strike through
     values that have no available variant given the other selections.
   - Add to cart: AJAX, then re-render + open the theme cart drawer and refresh
     the header count.

   Everything is delegated off `document`, so cards injected later (facet
   re-render, Load more, section re-render in the theme editor) work without
   re-binding.
   ========================================================================= */
(function () {
  if (window.__shopCardsBound) return;
  window.__shopCardsBound = true;

  function cardVariants(card) {
    if (card.__scVariants) return card.__scVariants;
    var el = card.querySelector('[data-sc-variants]');
    if (!el) return null;
    try { card.__scVariants = JSON.parse(el.textContent); } catch (e) { return null; }
    return card.__scVariants;
  }

  function selectedValues(card) {
    return Array.prototype.slice.call(card.querySelectorAll('[data-sc-opt]')).map(function (g) {
      if (g.hasAttribute('data-single-value')) return g.getAttribute('data-single-value');
      var a = g.querySelector('[data-sc-optval].is-active');
      return a ? a.getAttribute('data-value') : null;
    });
  }

  function findVariant(variants, vals) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < vals.length; j++) {
        if (variants[i].options[j] !== vals[j]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  function refresh(card) {
    if (!card) return;
    var variants = cardVariants(card);
    if (!variants) return;
    var vals = selectedValues(card);

    Array.prototype.slice.call(card.querySelectorAll('[data-sc-opt]')).forEach(function (g, gi) {
      Array.prototype.slice.call(g.querySelectorAll('[data-sc-optval]')).forEach(function (b) {
        var test = vals.slice();
        test[gi] = b.getAttribute('data-value');
        var tv = findVariant(variants, test);
        b.classList.toggle('is-oos', !tv || !tv.available);
      });
    });

    var vr = findVariant(variants, vals);
    var priceEl = card.querySelector('[data-sc-price]');
    var cmpEl = card.querySelector('[data-sc-compare]');
    var savEl = card.querySelector('[data-sc-save]');
    var addBtn = card.querySelector('[data-sc-add]');

    if (vr) {
      if (priceEl) priceEl.textContent = vr.price;
      if (cmpEl) { cmpEl.textContent = vr.compare || ''; cmpEl.hidden = !vr.compare; }
      if (savEl) { savEl.textContent = vr.save || ''; savEl.hidden = !vr.save; }
      if (addBtn) {
        addBtn.setAttribute('data-variant-id', vr.id);
        addBtn.disabled = !vr.available;
        addBtn.textContent = vr.available ? addBtn.dataset.cta : addBtn.dataset.soldout;
      }
    } else if (addBtn) {
      addBtn.disabled = true;
      addBtn.textContent = addBtn.dataset.soldout;
    }
  }

  function initCards() {
    document.querySelectorAll('[data-sc-card]').forEach(function (card) {
      if (card.dataset.scInit) return;
      card.dataset.scInit = '1';
      if (card.querySelector('[data-sc-options]')) refresh(card);
    });
  }

  if (document.readyState !== 'loading') initCards();
  else document.addEventListener('DOMContentLoaded', initCards);

  var ct;
  new MutationObserver(function () { clearTimeout(ct); ct = setTimeout(initCards, 60); })
    .observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', function (e) {
    var optBtn = e.target.closest('[data-sc-optval]');
    if (optBtn) {
      var group = optBtn.closest('[data-sc-opt]');
      Array.prototype.slice.call(group.querySelectorAll('[data-sc-optval]')).forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      optBtn.classList.add('is-active');
      optBtn.setAttribute('aria-pressed', 'true');
      refresh(optBtn.closest('[data-sc-card]'));
      return;
    }

    var btn = e.target.closest('[data-sc-add]');
    if (!btn || btn.disabled) return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;

    var label = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (r) { if (!r.ok) throw new Error('add-failed'); return r.json(); })
      .then(function () {
        var drawer = document.querySelector('cart-drawer');
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        if (!drawer) { window.location.href = '/cart'; return; }
        return fetch(base + '?section_id=cart-drawer')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('cart-drawer');
            if (fresh) { drawer.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
            try {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-card' });
              }
            } catch (err) {}
            if (typeof drawer.open === 'function') drawer.open();
            else { drawer.classList.add('active', 'animate'); document.body.classList.add('overflow-hidden'); }
            return fetch('/cart.js').then(function (r) { return r.json(); });
          });
      })
      .then(function (cart) {
        if (cart) {
          var b = document.querySelector('#cart-icon-bubble .hv2__badge');
          if (b) { b.textContent = cart.item_count; b.classList.toggle('is-empty', cart.item_count === 0); }
        }
        btn.textContent = 'Added ✓';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
      })
      .catch(function () { btn.textContent = label; btn.disabled = false; window.location = '/cart'; });
  });
})();
